import Component from '../core/Component'
import keycode from 'keycode'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
}
export default class Nav extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            layer: null,
        }

        this.state = {
            active: false,
            source: null,
        }
    }

    prepare() {
        this.element.addEventListener('transitionend', () => {
            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            } else {
                this.state.active = true
            }
        })

        this.element.addEventListener('click', this.handleClick)
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)
        EventBus.on('swup:clicklink', this.handleSwupClick)
    }

    destroy() {
        this.close()
        document.removeEventListener('keydown', this.handleKeydown)
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        if (this.state.active) {
            this.close()
        }
    }

    handleSwupClick = () => {
        if (this.state.active) {
            this.close()
        }
    }

    handleClick = (event) => {
        if (event.target.closest('a')) {
            this.close()
        }

        if (!this.ref.layer.contains(event.target)) {
            this.close()
        }
    }

    handleOuterClick = (event) => {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    handleKeydown = (event) => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    handleScroll = (event) => {
        if (this.state.active) {
            this.close()
        }
    }

    toggle({ source }) {
        if (this.state.active) {
            this.close({ source })
        } else {
            this.open({ source })
        }
    }

    close() {
        if (!this.state.active) {
            return
        }
        this.state.source = null
        this.state.active = false
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeydown)
        document.removeEventListener('click', this.handleOuterClick)
        EventBus.emit('nav:change', { status: 0 })
        EventBus.emit('nav:close')
    }

    open({ source }) {
        this.state.source = source
        this.position()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        document.addEventListener('keydown', this.handleKeydown)
        document.addEventListener('click', this.handleOuterClick)
        EventBus.emit('nav:open')
        EventBus.emit('nav:change', { status: 1 })
    }

    position() {
        if (!this.state.source) {
            return
        }

        const sourceBox = this.state.source.getBoundingClientRect()
        this.element.style.left = `${sourceBox.left - 14}px`
    }
}
